//IMMIGRATION AND CITIZENSHIP

import strs from './../strings';
import { Spacer, DragNDrop, handleUpload, EmptyElement, BackButton, BasicInfoForm, AddressForm, SubmissionArea, DropResult, PDFViewer, Spacer25, ConfirmNewCase, Spacer100, Children, LegalStatus, AuxCompletionProof, Licenses, HaveCompany, ExColony, NumJobs, SignaturePad, NoCasesAvailable, IsEmployerFirm, CompanyRepresentative, ResponsibleDeclarations, CriminalRecordsCheck, EmployerPerson, EmployerFirm } from '../Utils';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { FormContext } from '../context';
import { useInitCase } from './immigration_and_citizenship';
import { DocumentsGridPopup, FullscreenDocument } from '../Popups';
import { useState } from 'react';


const lang = strs.en;

function LoadingDocs() {
	return(
	<div className='animated-div'>
		<Spacer100 />
		<h3 className='secondary-title centered-text '><i>{lang.loadingDocs}</i></h3>
		<Spacer />
		<div className='center-flex logo-loading-rotate'>
			<img className='header__logo' alt="logo" src='/spinningLogo.png' />
		</div>
	</div>
	);
}

export function ArraigoSociolaboral(props) {
	const newProps = {
		...props,
		caseType: "arraigoSociolaboral"
	}
	console.log('arraigo sociiolaboral');
	const {globalForm, setGlobalForm, iframeDoc, setIframeDoc, isIframe, setIsIframe, docPrepop, docPrepopURLs, setDocPrepopURLs, isLoading, setIsLoading, confirmNewCase, setConfirmNewCase, value, smallChildren, setSmallChildren, numChildren, setNumChildren, passportStamp, setPassportStamp, saveCurCase, incrementChildren, decrementChildren, signatureImg, setSignatureImg, numOtherDocs, setNumOtherDocs, briefcasePopup, setBriefcasePopup, handleTextAreaChangeOtherDocs, isEmployerFirm, setIsEmployerFirm} = useInitCase(newProps);
	const [bgchkVisible, setBgchkVisible] = useState(globalForm.responsibleDecs?.bgchkExemption === 'bgchk' ? 'large-margin' : 'hidden');
	function handleClick(url) {
		console.log("HANDLECLICK")
		console.log("url", url)
		setIframeDoc(url);
		setIsIframe('pdf-viewer-fullscreen fade-in')
	}

	console.log("isEmployerFirm", isEmployerFirm);

	return  confirmNewCase ? <ConfirmNewCase setConfirmNewCase={setConfirmNewCase} />
		:

	(
	isLoading ? <LoadingDocs /> :

	<div>
		<FormContext.Provider value={value}>
		<BackButton />
		<Spacer />
		<div className='form-div'>
			<h1 className='primary-title'>{lang.arraigoSociolaboral}</h1>
			<Spacer />
				<h3 className='tertiary-title'>{lang.fullPassport}</h3>
				<Spacer25 />
				<div className=''>
				<div className='large-margin'>
				<DragNDrop 
					text=<div>{lang.fullPassport}  {<span style={{color: 'red'}}>*</span>}</div>
					doc='fullPassport' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					fileNanoID={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].uuid : false}
					initialFileURL={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].url : false}
					saveFunc={saveCurCase}
				/>
				</div>
				</div>

			<Spacer />
			<h3 className='tertiary-title'>{lang.requiredDocs}</h3>
			<div className='animated-div upload-grid'>
				<DragNDrop 
					text={lang.proofTwoYears} 
					doc='proofTwoYears' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					initialFileURL={docPrepopURLs['proofTwoYears'] ? docPrepopURLs['proofTwoYears'].url : false}
					fileNanoID={docPrepopURLs['proofTwoYears'] ? docPrepopURLs['proofTwoYears'].uuid : false}
					saveFunc={saveCurCase}
					globalForm={globalForm}
					setGlobalForm={setGlobalForm}
				/>

				<DragNDrop 
					text={lang.employmentContract} 
					doc='employmentContract' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					initialFileURL={docPrepopURLs['employmentContract'] ? docPrepopURLs['employmentContract'].url : false}
					fileNanoID={docPrepopURLs['employmentContract'] ? docPrepopURLs['employmentContract'].uuid : false}
					saveFunc={saveCurCase}
					globalForm={globalForm}
					setGlobalForm={setGlobalForm}

				/>
				<DragNDrop 
					text={lang.fee} 
					doc='fee' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					initialFileURL={docPrepopURLs['fee'] ? docPrepopURLs['fee'].url : false}
					fileNanoID={docPrepopURLs['fee'] ? docPrepopURLs['fee'].uuid : false}
					saveFunc={saveCurCase}
					globalForm={globalForm}
					setGlobalForm={setGlobalForm}
				/>

			</div>
			<Spacer />
			<CriminalRecordsCheck setBgchkVisible={setBgchkVisible}/>
			<Spacer />
			<div className={bgchkVisible}>
				<DragNDrop 
					text={lang.backgroundCheck} 
					doc='backgroundCheck' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					initialFileURL={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].url : false}
					fileNanoID={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].uuid : false}
					saveFunc={saveCurCase}
					globalForm={globalForm}
					setGlobalForm={setGlobalForm}
				/>
			</div>


			<Spacer />
			<Spacer />

			<h3 className='center-flex secondary-title'>{lang.children}</h3>
		{

		}
			<Children 
				smallChildren={smallChildren}
				setSmallChildren={setSmallChildren}
				setNumChildren={setNumChildren}
			/>
		{
			<div className={`${smallChildren ? '' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOrBoth}</p>
			{
				Array.from({length: numChildren}).map((_, i) => (
					<div className={`animated-div two-column-upload-grid`}>
						<DragNDrop 
							text={lang.childSchoolEnrollment + ` ${i+1}`} 
							doc={`childSchoolEnrollment${i+1}`}
							setBriefcasePopup={setBriefcasePopup}
							fileNanoID={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>

						<DragNDrop 
							text={lang.childCourseCompletion + ` ${i+1}`} 
							doc={`childCourseCompletion${i+1}`}
							setBriefcasePopup={setBriefcasePopup}
							fileNanoID={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>

					</div>
				))
			}

			<div className='center-flex'>
				<button className='form-action-btn new-btn' onClick={incrementChildren}>Add child +</button>
				<button className='form-action-btn new-btn' onClick={decrementChildren}>Delete child +</button>
			</div>

			</div>
		}

		{
			<>
			<Spacer100 />
			<h3 className='tertiary-title'>{lang.additionalDocs}</h3>
			<Spacer />
			<p className='larger-font centered-text'>{lang.anyAdditionalDocs}</p>
			<Spacer />

			{
			Array.from({ length: numOtherDocs }).map((_, i) => {
				console.log('message', docPrepopURLs[`other${i+1}`]);
				
				return(
				<div className='large-margin animated-div'>
					<DragNDrop text={lang.other} 
						doc={`other${i+1}`}
						setBriefcasePopup={setBriefcasePopup}
						clickCallback={handleClick} 
						customStyle='pdf-viewer-small' 
						initialFileURL={docPrepopURLs[`other${i+1}`] ? docPrepopURLs[`other${i+1}`].url : false}
						fileNanoID={docPrepopURLs[`other${i+1}`] ? docPrepopURLs[`other${i+1}`].uuid : false}
						saveFunc={saveCurCase}
						msg={docPrepopURLs[`other${i+1}`]?.msg}
					/>
					<Spacer />
					<div className='center-flex'>
					<textarea className='text-area' defaultValue={docPrepopURLs[`other${i+1}`] ? docPrepopURLs[`other${i+1}`].msg : ''} placeholder={lang.optionalMessage} onChange={(e) => handleTextAreaChangeOtherDocs(e, i)}></textarea>
					</div>
					<Spacer />
					<Spacer25 />
				</div>
				);
			})
			}

			<div className='center-flex'>
				<button className='form-action-btn new-btn' onClick={() => {
					setNumOtherDocs(numOtherDocs + 1);
				}}>{lang.addDocument} +</button>
			</div>
			</>
		}

			<Spacer100 />

			<h3 className='center-flex secondary-title'>{lang.basicInfo}</h3>
			<Spacer />
			<p className='centered-text p'>{lang.smartAutoFill}</p>
			<Spacer25 />
			<BasicInfoForm />
			<Spacer />
			<h3 className='center-flex secondary-title'>{lang.physicalAddress}</h3>
			<Spacer />
			<AddressForm />
			<Spacer />

			<Spacer />
			<h3 className='center-flex secondary-title'>{lang.employerData}</h3>
			<Spacer />
			<IsEmployerFirm isEmployerFirm={isEmployerFirm} setIsEmployerFirm={setIsEmployerFirm}/>

			<Spacer25 />
			{
				<div>
					<div className={isEmployerFirm === false ? '' : 'hidden'}>
						<EmployerPerson />
					</div>
					<div className={isEmployerFirm === true ? '' : 'hidden'}>
						<EmployerFirm />
					</div>
				</div>
			}
			<Spacer />

			<h3 className='center-flex quad-title'>{lang.employerAddress}</h3>
			<AddressForm employer={true} />
			<Spacer />
			<ResponsibleDeclarations />
			<Spacer />
			<h3 className='tertiary-title'>{lang.signaturePad}</h3>
			<Spacer25 />
			<p className='p centered-text'>{lang.signatureForm}</p>
			<Spacer />
			<div className='center-flex'>
				<SignaturePad saveFunc={saveCurCase} updateSignatureImg={setSignatureImg} />
			</div>

			<SubmissionArea saveFunc={saveCurCase}/>

	<FullscreenDocument visible={isIframe} closeFunc={setIsIframe} src={iframeDoc} />
	<DocumentsGridPopup onSelect={() => {console.log('onSelect')}} isVisible={briefcasePopup} setIsVisible={setBriefcasePopup}/>


		</div>
		</FormContext.Provider>
	</div>
	)

}

